import { forOwn } from 'lodash';
import { BREAKPOINTS } from '../variables/breakpoints';
import { TEXT_SIZES } from '../variables/typography';
/* USAGE */

/*
import styled from '@emotion/styled';
import { setFont } from '@titelmedia/bricks-theme/lib/utilities/typography';

export const Title = styled.h3`
  ${props => setFont({bold: props.bold, display: props.display})}
  ${setFontSizes({ mobile: '1rem', tablet_vertical: '48px' })}
`;
*/

export var setFont = function setFont(props) {
  var correctFont = 'univers-roman';

  if (props.bold) {
    correctFont = 'univers-bold';
  } else if (props.serif || props.display) {
    correctFont = 'hs-deville';
  }

  if (props.headline) {
    correctFont = 'univers-black';
  }

  if (props.condensed) {
    correctFont = 'univers-bold-cond';
  }

  return "font-family: ".concat(correctFont, ";");
};
export var setFontSizes = function setFontSizes(_ref) {
  var mobile = _ref.mobile,
      tablet_vertical = _ref.tablet_vertical,
      tablet_horizontal = _ref.tablet_horizontal,
      desktop = _ref.desktop,
      desktop_large = _ref.desktop_large;
  var fontSizeProps = {
    mobile: mobile,
    tablet_vertical: tablet_vertical,
    tablet_horizontal: tablet_horizontal,
    desktop: desktop,
    desktop_large: desktop_large
  };
  var style = '';
  forOwn(fontSizeProps, function (val, breakpoint) {
    if (val) {
      if (breakpoint === 'mobile') {
        style += "font-size: ".concat(TEXT_SIZES[val] || val, ";");
      } else {
        style += "\n                @media (min-width: ".concat(BREAKPOINTS[breakpoint], "px) {\n                    font-size: ").concat(TEXT_SIZES[val] || val, ";\n                }\n            ");
      }
    }
  });
  return style;
};